module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"subscriptions":"Abos","shop":"Shop"},"en":{"subscriptions":"Subscriptions","shop":"Shop"}}')
  delete Component.options._Ctor
}
